import { withStyles } from 'material-ui/styles';
import React, { Component } from 'react';

import { TextFieldFormsy } from '@fuse';
import Formsy from 'formsy-react';
import { Button, Icon, IconButton, Typography } from 'material-ui';

import axios from 'axios/index';
import Dialog, {
    DialogContent,
    DialogTitle
} from 'material-ui/Dialog';
import ReactTable from "react-table";

import Loader from "other-components/loader/loader";
import { withAlert } from 'react-alert';

import Select from 'react-select';



const styles = theme => ({
    layoutRoot: {},

    smaller: {
        width: 30,
        height: 20,
    }
});


class UnitConversion extends Component {

    constructor(props) {
        super(props);
        this.state = {
            canSubmit: false,
            canSubmit2: false,
            data: [],
            open: false,
            editValues: {
                unitType: null,
                status: null
            },
            unitTypes: [],
            unitCategories: [],
            unitCategories2: [],
            unitCategory2: '',
            loading: true
        };

        this.onDropdownSelected = this.onDropdownSelected.bind(this);

        this.updateCategories();
    }



    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    enableButton = () => {
        this.setState({ canSubmit: true });
    };

    enableButton2 = () => {
        this.setState({ canSubmit2: true });
    };

    disableButton = () => {
        this.setState({ canSubmit: false });
    };

    disableButton2 = () => {
        this.setState({ canSubmit2: false });
    };

    handleUnitCategoryChange = (selectedOption) => {
        if (selectedOption) {
            this.setState({ unitCategory2: selectedOption.value });
        }
        else {
            this.setState({ unitCategory2: '' });

        }
    }

    editUnitTypes = (model) => {

        this.setState({ loading: true });

        let unitType = {
            catagory_name: this.state.editValues.unitCategory,
            unit_type_name: this.state.editValues.unitType,
            unit_type_name_new: model.name
        }

        var url = window.systemServer + "/system/updateUnitTypeData";

        const request = axios.post(url, unitType);

        request.then((response) => {

            if (!response.data.error && response.data.success) {
                console.log('data recieved', response.data);

                this.updateCategories();
                this.handleClose();
                this.props.alert.success('Unit Type Changed');

            }
            else {
                if (!response.data.success && response.data.message == 'duplicate') {
                    this.props.alert.error('Duplicate unit type');
                }
                else {
                    this.props.alert.error('Error');
                }
                this.setState({ loading: false });
                this.handleClose();

                console.log('error', response.data);
            }
        })
            .catch((error) => {

                this.handleClose();
                // Error
                if (error && typeof error === 'undefined') {

                    console.log('login axios error block', error);
                    this.setState({ loading: false });
                    this.props.alert.error('Unsuccessful');
                }
                else if (error) {
                    console.log('error');
                    this.setState({ loading: false });
                    this.props.alert.error('Unsuccessful');
                }
            });
    };



    deleteUnitType = (name, isActive) => {

        this.setState({ loading: true });

        let unitType = {
            name: name
        };

        var url;
        var message;
        if (isActive) {
            url = window.systemServer + "/system/deactivateUnitType";
            message = "Unit is inactive";
        }
        else {
            url = window.systemServer + "/system/reactivateUnitType";
            message = "Unit is active";
        }

        const request = axios.post(url, unitType);

        request.then((response) => {

            if (!response.data.error) {
                console.log('data recieved', response.data);

                this.updateCategories();

                this.props.alert.success(message);



                //this.refs.form.reset();

                //this.handleClose();

                /* let data = [];
                data = (response.data.slice());
                this.setState({data:data});
                console.log(this.state.data); */
            }
            else {
                console.log('error', response.data.error);

                this.props.alert.error('Unsuccessful');

                this.setState({ loading: false });
            }
        })
            .catch((error) => {
                // Error
                if (error && typeof error === 'undefined') {
                    console.log('login axios error block', error);
                    this.setState({ loading: false });
                    this.props.alert.error('Unsuccessful');
                }
                else if (error) {
                    console.log('error');
                    this.setState({ loading: false });
                    this.props.alert.error('Unsuccessful');
                }
            });

        //deactivateUnitType
    };

    addUnitType = (model) => {

        let unitType = {
            unit_type: { name: model.unitType, unit_type_description: null },
            //unit_catagory_name:  model.unitCategory
            unit_catagory_name: this.state.unitCategory2
        }

        var url = window.systemServer + "/system/createUnitTypes";

        const request = axios.post(url, unitType);

        request.then((response) => {

            if (!response.data.error && response.data.success) {
                console.log('data recieved', response.data);

                this.props.alert.success('Unit type added');

                this.updateCategories();

                //this.refs.form.reset();
                this.setState({ unitCategory2: '' })

                /* let data = [];
                data = (response.data.slice());
                this.setState({data:data});
                console.log(this.state.data); */
            }
            else {
                if (!response.data.success && response.data.message && response.data.message == 'duplicate') {
                    this.props.alert.error('Duplicate unit type');
                }
                else {
                    this.props.alert.error('Error2');
                    console.log('error', response.data.error);
                }
            }
        })
            .catch((error) => {
                // Error
                this.props.alert.error('Error3');
                console.log('error', error);

                if (error && typeof error === 'undefined') {
                    console.log('login axios error block', error);
                }
                else if (error) {
                    console.log('error');
                }
            });
    };



    updateCategories() {
        this.setState({ loading: true });
        const request = axios.get(window.systemServer + '/system/loadActiveUnitCatagory');
        request.then((response) => {
            if (window.DATABASE_TYPE == "MYSQL")
                if (response.data.success) {
                    console.log('data recieved', response.data.result);

                    let unitCategories = [];
                    let unitCategories2 = [];
                    let unitTypes = [];
                    unitCategories = response.data.result.map(item => item.unit_catagory_name);
                    response.data.result.map(item => {
                        let t = { value: item.unit_catagory_name, label: item.unit_catagory_name };
                        unitCategories2.push(t);
                    });


                    response.data.result.map(item => {
                        if (item.unitType){
                            item.unitType.map(uType => {
                                uType.unitCategory = item.unit_catagory_name;
                                unitTypes.push(uType);
                            });
                        }

                        /* var t = unitTypes.concat(item.unit_type);
                        unitTypes = t.slice(); */
                    });
                    console.log('unitTypes', unitTypes);
                    this.setState({ unitTypes: unitTypes });
                    this.setState({ unitCategories: unitCategories });
                    this.setState({ unitCategories2: unitCategories2 });
                    this.setState({ unitCategory2: '' });
                    this.setState({ loading: false });

                }
                else {
                    console.log('error', response.data);
                    this.setState({ loading: false });
                }
            else
                if (!response.data.error) {
                    console.log('data recieved', response.data);

                    let unitCategories = [];
                    let unitCategories2 = [];
                    let unitTypes = [];
                    unitCategories = response.data.map(item => item.unit_catagory_name);
                    response.data.map(item => {
                        let t = { value: item.unit_catagory_name, label: item.unit_catagory_name };
                        unitCategories2.push(t);
                    });


                    response.data.map(item => {
                        item.unit_type.map(uType => {
                            uType.unitCategory = item.unit_catagory_name;
                            unitTypes.push(uType);
                        });

                        /* var t = unitTypes.concat(item.unit_type);
                        unitTypes = t.slice(); */
                    });
                    console.log('unitTypes', unitTypes);
                    this.setState({ unitTypes: unitTypes });
                    this.setState({ unitCategories: unitCategories });
                    this.setState({ unitCategories2: unitCategories2 });
                    this.setState({ unitCategory2: '' });
                    this.setState({ loading: false });

                }
                else {
                    console.log('error', response.data.error);
                    this.setState({ loading: false });
                }
        });
    }

    /* getUnitTypes(){
        const request = axios.get(window.systemServer+'/system/loadUnitCatagory');
        request.then((response) => {

            if (!response.data.error) {
                console.log('data recieved', response.data);

                let data = [];
                data = (response.data.slice());
                this.setState({ data: data });
                console.log(this.state.data);
            }
            else {
                console.log('error', response.data.error);
            }
        });
    } */

    onDropdownSelected(e) {
        // alert( e.target.value);
        //here you will see the current selected value of the select input
    }

    componentWillMount() {

    }



    render() {

        const { classes } = this.props;

        if (this.state.loading) {
            return (


                <Loader />

            );
        }
        else {

            return (
                <div className="p-20">
                    <Typography className="h2 mb-24 subtitle-color">Unit Type</Typography>
                    <Formsy
                        onValidSubmit={this.addUnitType}
                        onValid={this.enableButton}
                        onInvalid={this.disableButton}
                        ref="form"
                        className=" py-20"
                    >

                        <div className="">

                            {/* <SelectFormsy
                                        className="md:w-1/5 px-20"
                                        name="unitCategory"
                                        label="Trade"
                                        value="none"
                                        //validations="equals:none"
                                        //validationError="Must be None"
                                    >


                                        <MenuItem value="none" ref="tradeMenu">
                                            <em>Select Unit Category</em>
                                        </MenuItem>
                                        {this.state.unitCategories.map(function (item, i) {
                                            return <MenuItem value={item}>{item}</MenuItem>;
                                        })}

                                    </SelectFormsy> */}

                            {/* <div className="md:w-1/5 block mb-12"> */}
                            <div className="flex flex-row flex-wrap">
                                <Select
                                    className="flex flex-1 flex-col max-w-256 min-w-256 p-20"
                                    name="form-field-name"
                                    placeholder="Select Unit Category"
                                    value={this.state.unitCategory2}
                                    onChange={this.handleUnitCategoryChange}
                                    options={this.state.unitCategories2}
                                />

                                <div className="md:w-1/5 block mb-12">
                                    <TextFieldFormsy
                                        className="flex flex-1 flex-col min-w-256 p-21"
                                        type="text"
                                        name="unitType"
                                        label="Unit Type"
                                        validations={{
                                            minLength: 4
                                        }}
                                        validationErrors={{
                                            minLength: 'Min character length is 4'
                                        }}
                                        required
                                    />
                                </div>

                                <div className="md:w-1/5 block unit-category-btn">
                                    <Button

                                        type="submit"
                                        variant="raised"
                                        color="secondary"
                                        className="mx-auto mt-16"
                                        aria-label="Add"
                                        disabled={!this.state.canSubmit || !this.state.unitCategory2
                                            || this.state.unitCategory2 == ''}
                                    >
                                        Add New
                                    </Button>
                                </div>
                            </div>

                        </div>

                    </Formsy>

                    <ReactTable
                        data={this.state.unitTypes}
                        columns={[

                            {
                                Header: "Name",
                                filterable: true,
                                accessor: "name",
                                Cell: ({ row, original }) => (
                                    <span>
                                        <span style={{

                                            color: original.isActive ? '#57d500' : '#Ff0000',
                                            transition: 'all .3s ease'
                                        }}>
                                            &#x25cf;
                                        </span>
                                        {
                                            row.name
                                        }
                                    </span>
                                )
                            },
                            {
                                Header: "Base Unit",
                                Cell: row => <span>{row.original.baseUnit ? "Yes" : "No"}</span>
                            }
                            ,
                            {
                                Header: "Action",
                                width: 128,
                                className: "justify-center",
                                Cell: row => (
                                    row.original.isActive == true ?
                                        <div className="flex items-center">
                                            <IconButton
                                                className={classes.smaller}
                                                title="Do you want to inactive?"
                                                onClick={(ev) => {
                                                    ev.stopPropagation();
                                                    this.deleteUnitType(row.original.name, row.original.isActive)
                                                }}

                                            >
                                                <Icon className='text-green'>check_circle</Icon>
                                            </IconButton>

                                            <IconButton
                                                className={classes.smaller}
                                                title="Edit"
                                                onClick={(ev) => {
                                                    ev.stopPropagation();
                                                    this.setState({
                                                        editValues: {
                                                            unitType: row.original.name,
                                                            unitCategory: row.original.unitCategory,
                                                            status: row.original.isActive
                                                        }
                                                    });
                                                    this.handleClickOpen();
                                                }}

                                            >
                                                <Icon className="text-blue">mode_edit</Icon>
                                            </IconButton>


                                            <Dialog open={this.state.open} onClose={this.handleClose} aria-labelledby="form-dialog-title" >
                                                <DialogTitle id="form-dialog-title">Change Unit Type</DialogTitle>
                                                <DialogContent>

                                                    <Formsy
                                                        onValidSubmit={this.editUnitTypes}
                                                        onValid={this.enableButton2}
                                                        onInvalid={this.disableButton2}
                                                        ref="form2"
                                                        className="flex flex-col justify-center"
                                                    >

                                                        <div className="flex flex-row flex-wrap">
                                                            <TextFieldFormsy
                                                                className="flex flex-1 flex-col max-w-256 min-w-256 p-20"
                                                                type="text"
                                                                name="name"
                                                                label="Unit Type"
                                                                value={this.state.editValues.unitType}
                                                                validations={{
                                                                    minLength: 1
                                                                }}
                                                                validationErrors={{
                                                                    minLength: 'Min character length is 1'
                                                                }}
                                                                required
                                                            />

                                                            {/* <TextFieldFormsy
                                                                    className="flex flex-1 flex-col min-w-256 p-20"
                                                                    type="text"
                                                                    name="description"
                                                                    label="Description"
                                                                    value = {this.state.editValues.categoryDescription}
                                                                    validations={{
                                                                        minLength: 4
                                                                    }}
                                                                    validationErrors={{
                                                                        minLength: 'Min character length is 4'
                                                                    }}
                                                                    required
                                                                /> */}

                                                            <div className="max-w-256 p-20">
                                                                <Button
                                                                    color="primary"
                                                                    className="mx-auto mt-16"
                                                                    onClick={
                                                                        (ev) => {
                                                                            ev.stopPropagation();
                                                                            this.handleClose();
                                                                        }
                                                                    }
                                                                >
                                                                    Close
                                                                </Button>

                                                                <Button
                                                                    type="submit"
                                                                    variant="raised"
                                                                    color="primary"
                                                                    className="mx-auto mt-16"
                                                                    aria-label="Save"
                                                                    disabled={!this.state.canSubmit2}
                                                                >
                                                                    Change
                                                                </Button>
                                                            </div>

                                                        </div>
                                                    </Formsy>


                                                </DialogContent>
                                                {/* <DialogActions>
                                                        <Button onClick={this.handleClose} color="primary">
                                                            {this.state.editValues.categoryName}
                                                        </Button>
                                                        <Button onClick={this.handleClose} color="primary">
                                                            Subscribe
                                                        </Button>
                                                    </DialogActions> */}
                                            </Dialog>

                                        </div>
                                        :
                                        (<div className="flex items-center">
                                            <IconButton
                                                className={classes.smaller}
                                                title="Do you want to active?"
                                                onClick={(ev) => {
                                                    ev.stopPropagation();
                                                    this.deleteUnitType(row.original.name, row.original.isActive)
                                                }}

                                            >
                                                <Icon className='text-red'>cancel</Icon>
                                            </IconButton>

                                        </div>)
                                )
                            }
                        ]}
                        defaultPageSize={10}
                        className="-striped -highlight"
                    />
                </div>
            );

        }
    }
}

export default withStyles(styles, { withTheme: true })(withAlert(UnitConversion));


// WEBPACK FOOTER //
// ./src/main/content/system/unit-type/unitType.js